/* eslint-disable */
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Package, Plus } from "lucide-react";
import { goodsApi } from "./api";
import "./GoodsPage.css";

const CATEGORIES = ["All", "Electronics", "Furniture", "Books", "Clothing", "Kitchen", "Sports", "Other"];

export default function GoodsPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [q, setQ] = useState("");
  const [category, setCategory] = useState("");
  const [mine, setMine] = useState(false);

  useEffect(() => {
    setLoading(true);
    setError("");
    const params = {};
    if (q) params.q = q;
    if (category) params.category = category;
    if (mine) params.mine = true;
    goodsApi.list(params).then((d) => {
      setItems(d.items);
      setLoading(false);
    }).catch((e) => {
      setError(e.message || "Could not load listings");
      setLoading(false);
    });
  }, [q, category, mine]);

  return (
    <div className="gds-page">
      <div className="gds-top">
        <h1 className="gds-heading">Marketplace</h1>
        <button className="gds-new-btn" onClick={() => navigate("/goods/new")}>
          <Plus size={16} /> List an item
        </button>
      </div>

      <div className="gds-filters">
        <input
          className="gds-search"
          type="text"
          placeholder="Search items…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <div className="gds-tabs">
          <button
            className={`gds-tab${!mine ? " active" : ""}`}
            onClick={() => setMine(false)}
          >
            All
          </button>
          <button
            className={`gds-tab${mine ? " active" : ""}`}
            onClick={() => setMine(true)}
          >
            My listings
          </button>
        </div>
      </div>

      <div className="gds-tabs" style={{ marginBottom: "1rem", flexWrap: "wrap", gap: "0.4rem" }}>
        {CATEGORIES.map((cat) => (
          <button
            key={cat}
            className={`gds-tab${category === (cat === "All" ? "" : cat) ? " active" : ""}`}
            onClick={() => setCategory(cat === "All" ? "" : cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="gds-loading">Loading…</div>
      ) : error ? (
        <div className="gds-empty">{error}</div>
      ) : items.length === 0 ? (
        <div className="gds-empty">No listings found. Be the first to list something!</div>
      ) : (
        <div className="gds-grid">
          {items.map((item) => (
            <Link key={item.id} to={`/goods/${item.id}`} className="gds-card">
              {item.photos && item.photos.length > 0 ? (
                <img
                  className="gds-photo"
                  src={goodsApi.photoUrl(item.id, item.photos[0].id)}
                  alt={item.title}
                  onError={(e) => { e.currentTarget.style.display = "none"; }}
                />
              ) : (
                <div className="gds-photo-placeholder">
                  <Package size={40} />
                </div>
              )}
              <div className="gds-card-body">
                <p className="gds-card-title">{item.title}</p>
                {item.price != null ? (
                  <p className="gds-card-price">₹{item.price.toLocaleString("en-IN")}</p>
                ) : (
                  <p className="gds-card-free">Free</p>
                )}
                <p className="gds-card-meta">
                  {[item.category, item.condition].filter(Boolean).join(" · ")}
                  {item.seller ? ` · ${item.seller.name}` : ""}
                </p>
                {item.status === "sold" && <span className="gds-card-sold">SOLD</span>}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
